import { isDate, isEmpty, isString } from './stringHelper'

const dirtyValues = (dirtyFields, allValues) => {
  // NOTE: Recursive function.

  // If *any* item in an array was modified, the entire array must be submitted, because there's no
  // way to indicate "placeholders" for unchanged elements. `dirtyFields` is `true` for leaves.

  if (dirtyFields === true) {
    // console.log(`Return All value of ${dirtyFields}`, allValues)
    return allValues
  }

  if (Array.isArray(dirtyFields)) {
    return allValues

    // return dirtyFields.map((field, index) => dirtyValues(field, allValues[index]));
  }

  const realDirtyFields = Object.fromEntries(Object.entries(dirtyFields).filter((field) => field[1] !== false))

  // Here, we have an object.
  return Object.fromEntries(
    Object.keys(realDirtyFields)
      .map((key) =>
        // console.log("Key", key)
        // console.log("dirtyFields[key]", dirtyFields[key])
        // console.log(" allValues[key]",  allValues[key])
        [key, dirtyValues(dirtyFields[key], allValues[key])]
      )
      .filter((field) => {
        if (isDate(field[1]) || Array.isArray(field[1]) || typeof field[1] === 'boolean') {
          return true
        }

        if (isString(field[1])) {
          return true
        }
        return !isEmpty(field[1])
      })
  )
}

export default dirtyValues
